"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createActionLog = createActionLog;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

function createActionLog(options) {
  var _options$snapshotInte = options.snapshotInterval,
      snapshotInterval = _options$snapshotInte === void 0 ? 20 : _options$snapshotInte;
  var _options$limit = options.limit,
      limit = _options$limit === void 0 ? 200 : _options$limit;
  var store;
  var chunks = [];
  var skipped = 0;

  function countActionsInChunks() {
    return (chunks.length - 1) * (snapshotInterval || 0) + chunks[chunks.length - 1].actions.length;
  }

  function cull() {
    if (limit == null || snapshotInterval == null) return;
    var extraActionsCount = countActionsInChunks() - limit;
    var firstNecessaryChunk = Math.floor(extraActionsCount / snapshotInterval);

    if (firstNecessaryChunk > 0) {
      chunks.splice(0, firstNecessaryChunk);
      skipped += firstNecessaryChunk * snapshotInterval;
    }
  }

  var enhancer = function enhancer(createStore) {
    return function (reducer, initialState, enhancer) {
      if (store) throw new Error('redux-action-log enhancer can not be re-used');
      store = createStore(reducer, initialState, enhancer);
      var _store = store,
          _dispatch = _store.dispatch;
      chunks.push({
        state: initialState,
        actions: []
      });
      return (0, _objectSpread2.default)({}, store, {
        dispatch: function dispatch(action) {
          var lastChunk = chunks[chunks.length - 1];
          var actionEntry = {
            action: action,
            timestamp: Date.now()
          };

          if (lastChunk.actions.length === snapshotInterval) {
            chunks.push({
              state: store.getState(),
              actions: [actionEntry]
            });
          } else {
            lastChunk.actions.push(actionEntry);
          }

          cull();
          return _dispatch(action);
        }
      });
    };
  };

  return {
    enhancer: enhancer,
    setLimit: function setLimit(n) {
      limit = n;
      cull();
    },
    getLog: function getLog() {
      var _ref;

      return {
        initialState: chunks[0].state,
        skipped: skipped,
        actions: (_ref = []).concat.apply(_ref, (0, _toConsumableArray2.default)(chunks.map(function (c) {
          return c.actions;
        })))
      };
    },
    clear: function clear() {
      skipped += countActionsInChunks();
      chunks = [{
        state: store.getState(),
        actions: []
      }];
    }
  };
}